import React from "react";
import Modal from "react-modal";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import styles from "./Dialog.module.css";

type DialogType = React.FunctionComponent<{
	title: string;
	className?: string;
	size?: "large" | "fit";
	isOpened: boolean;
	onClose: () => void;
}>;

const Dialog: DialogType = ({ title, className, size, children, isOpened, onClose }) => {
	return (
		<Modal
			isOpen={isOpened}
			onRequestClose={onClose}
			className={clsx(styles.Dialog, size && styles[size])}
			overlayClassName={styles.Overlay}
		>
			<div className={styles.title}>
				<div className={styles.titleContent}>{title}</div>
				<div className={styles.close} onClick={onClose}>
					<FontAwesomeIcon icon={faTimes} />
				</div>
			</div>
			<div className={clsx(styles.content, className)}>{children}</div>
		</Modal>
	);
};

export default Dialog;
